export const LOADING_WEBSITEBUILDERS = "LOADING_WEBSITEBUILDERS";
export const GET_WEBSITEBUILDERS_LIST = "GET_WEBSITEBUILDERS_LIST";
export const GET_WEBSITE = "GET_WEBSITE";
export const REMOVE_WEBSITEBUILDERS = "REMOVE_WEBSITEBUILDERS";
export const ADD_WEBSITEBUILDERS = "ADD_WEBSITEBUILDERS";
export const UPDATE_WEBSITEBUILDERS = "UPDATE_WEBSITEBUILDERS";
export const GET_WEBSITEBUILDERS_BY_ID = "GET_WEBSITEBUILDERS_BY_ID";